import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

import { useTranslation } from 'react-i18next';
export default function StickyMobileCTA() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has dismissed this session
    const dismissed = sessionStorage.getItem("stickyCtaDismissed");
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    sessionStorage.setItem("stickyCtaDismissed", "true");
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      role="complementary"
      aria-label={t('sticky_mobile_c_t_a.mobile_call_to_action')}
    >
      <div className="bg-amber-500 text-black px-4 py-3 flex items-center justify-between gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
        <Link
          to="/register"
          className="flex-1 flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-sm"
        >
          Start Free Trial — $0 for 7 days
        </Link>
        <button
          onClick={handleDismiss}
          className="p-1 hover:bg-black/10 rounded transition-colors shrink-0"
          aria-label={t('sticky_mobile_c_t_a.dismiss')}
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
